import { useEffect, useState } from "react";
import type {
  FeapiError,
  UseQueryResult,
} from "@edreamsodigeo/frontend-api-client";

import useMembershipSubscriptionOffersQuery from "~/clientState/hooks/useMembershipSubscriptionOffersQuery";
import type {
  SubscriptionOfferPeriod,
  SubscriptionOffersQuery,
  SubscriptionOffersQueryVariables,
  SubscriptionResponse,
} from "~/generated/graphql";

export interface GetSubscriptionOffers {
  offers: Array<SubscriptionResponse>;
  loading: UseQueryResult<
    SubscriptionOffersQuery,
    SubscriptionOffersQueryVariables
  >["loading"];
  error: UseQueryResult<
    SubscriptionOffersQuery,
    SubscriptionOffersQueryVariables
  >["errors"];
}
export interface useGetSubscriptionOffersProps {
  offerPeriod?: SubscriptionOfferPeriod;
}

const filterOffersByPeriod = ({
  offers,
  period,
}): Array<SubscriptionResponse> =>
  offers.filter(
    (offer: SubscriptionResponse) => offer.subscriptionPeriod === period,
  );

const useGetSubscriptionOffers = ({
  offerPeriod,
}: useGetSubscriptionOffersProps = {}): GetSubscriptionOffers => {
  const { data, loading, errors } = useMembershipSubscriptionOffersQuery();
  const [error, setError] = useState<FeapiError[] | null>(null);
  const [offers, setOffer] = useState<Array<SubscriptionResponse>>([]);

  useEffect(() => {
    if (!loading) {
      if (errors) {
        setError(errors);
      }
      if (data?.subscriptionOffers) {
        if (offerPeriod) {
          setOffer(
            filterOffersByPeriod({
              offers: data.subscriptionOffers,
              period: offerPeriod,
            }),
          );
        } else {
          setOffer(data.subscriptionOffers as Array<SubscriptionResponse>);
        }
      }
    }
  }, [data, loading, errors, setOffer, offerPeriod]);

  return {
    offers,
    loading,
    error,
  };
};

export default useGetSubscriptionOffers;
